/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-23 10:35:38
 *
 * LastModified: 2017-05-23 10:35:38
 *-------------------------------------------------------*/

import LocalStorage from '../utils/LocalStorage'

if (!LocalStorage.getItem('language')) {
  let browserLang = navigator.language || 'en-US'
  if (browserLang.length >= 2) {
    browserLang = browserLang.substr(0, 2)
  }
  if (browserLang !== 'en' && browserLang !== 'ja') {
    browserLang = 'en'
  }
  LocalStorage.setItem('language', browserLang)
}

const language = (state = LocalStorage.getItem('language'), action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      LocalStorage.setItem('language', action.language)
      return action.language
    default:
      return state
  }
}

module.exports = language



// WEBPACK FOOTER //
// ./reducers/language.js